import IconButton from '@mui/material/IconButton';
import styled from 'styled-components';

const NotesIframe = styled.iframe`
    height: 100vh;
    border: none;
`;

const NotesHeader = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  background-color: ${({ theme }) => theme.palette.backdrop.light};
  border-bottom: 1px solid ${({ theme }) => theme.palette.backdrop.dark};
  /* box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75); */
`;

const CloseIconButton = styled(IconButton)`
  && {
    position: absolute;
    right: ${({ theme }) => theme.spacing(2)};
  }
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export { NotesIframe, MessageContainer, CloseIconButton, NotesHeader };
